import { render, staticRenderFns } from "./OptimizationGroupList.vue?vue&type=template&id=0487f87c&scoped=true"
import script from "./OptimizationGroupList.vue?vue&type=script&lang=js"
export * from "./OptimizationGroupList.vue?vue&type=script&lang=js"
import style0 from "./OptimizationGroupList.vue?vue&type=style&index=0&id=0487f87c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487f87c",
  null
  
)

export default component.exports